export default "__VITE_ASSET__db8bcf6c__"